<script>
	export let badge;
</script>

<div class="flex items-center justify-start">
	<div class="nx-badge flex-shrink-0 bg-contain bg-center bg-no-repeat" style="background-image: url({badge.urls.image})" />
	<div class="ml-4 flex flex-col items-start justify-start">
		<div class="text-lg font-medium text-brand-gray">{badge.name}</div>
		<div class="mt-1 text-14 font-normal leading-tight text-brand-gray-70">{badge.description}</div>
	</div>
</div>

<style>
	.nx-badge {
		width: 78px;
		height: 87px;
	}
</style>
